"use strict";
// @ts-nocheck    悲伤， typescript 不能默认导入 .vue 的...
Object.defineProperty(exports, "__esModule", { value: true });
const select_1 = require("./components/select");
const basicForm_1 = require("./components/basicForm");
const checkbox_1 = require("./components/checkbox");
const textInput_1 = require("./components/textInput");
const numberInput_1 = require("./components/numberInput");
const arrayTable_1 = require("./components/arrayTable");
const defaultComponentList = [
    select_1.selectModule,
    basicForm_1.basicFormModule,
    checkbox_1.checkboxModule,
    textInput_1.textInputModule,
    numberInput_1.numberInputModule,
    arrayTable_1.arrayTableModule,
];
exports.default = defaultComponentList;
//# sourceMappingURL=components.js.map